export const firebaseConfig = {
  apiKey: "AIzaSyCP9XFjpb9bSlgLcOxKJNrCO_NP4KbwaVg",
  authDomain: "cursostic-a0f31.firebaseapp.com",
  projectId: "cursostic-a0f31",
  storageBucket: "cursostic-a0f31.appspot.com",
  messagingSenderId: "453618127344",
  appId: "1:453618127344:web:7cd8071dea417894048d35"
};